// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes page-transition-slide-in {
  from {
    transform: translateX(7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-reverse-slide-in {
  from {
    transform: translateX(-7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-slide-out {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-7.5rem);
  }
}
@keyframes width-grow {
  from {
    transform: scaleX(0.001);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes width-shrink {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0.001);
  }
}
@keyframes height-grow {
  from {
    transform: scaleY(0.0001);
  }
  to {
    transform: scaleY(1);
  }
}
@keyframes height-fade-and-grow {
  from {
    opacity: 0;
    transform: scaleY(0.0001);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes height-shrink {
  from {
    transform: scaleY(1);
  }
  to {
    transform: scaleY(0.001);
  }
}
@keyframes roll-in {
  from {
    opacity: 0;
    transform: translateX(10rem) rotate(500deg);
  }
  to {
    opacity: 1;
    transform: translateX(0) rotate(0);
  }
}
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateX(5rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slide-out {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-5rem);
  }
}
@keyframes drop {
  0% {
    transform: translateY(-1rem);
  }
  100% {
    transform: translateY(0);
  }
}
app-root .summary-page.lf h1 {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  margin-bottom: 0;
}
app-root .summary-page .summary .summary-header h2,
app-root .summary-page .summary dt {
  margin-right: 0.5rem;
}
app-root .summary-page .summary .summary-value {
  margin-right: 0.375rem;
}
app-root .summary-page .summary .summary-header h2 {
  display: inline;
  margin-right: 0.375rem;
}
app-root .summary-page .summary a.edit-link {
  font-size: 0.875rem;
  display: inline-block;
  padding: 0.125rem 0.375rem;
  padding-bottom: 0;
  margin-right: -0.375rem;
  margin-left: -0.375rem;
  text-decoration: none;
  font-weight: 600;
  color: var(--primary);
  transition: color 0.2s ease-in-out, transform 0.1s ease-in-out;
}
app-root .summary-page .summary a.edit-link:visited {
  color: var(--primary);
}
app-root .summary-page .summary a.edit-link:hover {
  color: var(--hover-primary);
}
app-root .summary-page .summary a.edit-link:active {
  transform: translateY(7%);
}
app-root .summary-page.slide-in .summary .summary-entry {
  will-change: transform, opacity;
  animation: 0.25s ease-in normal backwards 0s fade-in, 0.3s cubic-bezier(0.39, 0.67, 0.61, 0.96) normal backwards 0s page-transition-slide-in;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(1) {
  animation-delay: 0.15s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(2) {
  animation-delay: 0.21s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(3) {
  animation-delay: 0.27s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(4) {
  animation-delay: 0.33s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(5) {
  animation-delay: 0.39s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(6) {
  animation-delay: 0.45s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(7) {
  animation-delay: 0.51s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(8) {
  animation-delay: 0.57s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(9) {
  animation-delay: 0.63s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(10) {
  animation-delay: 0.69s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(11) {
  animation-delay: 0.75s;
}
app-root .summary-page.slide-in .summary .summary-entry:nth-of-type(12) {
  animation-delay: 0.81s;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Views/Summary/SummaryPage.less","webpack://./src/Styles/animations.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;ACPE;EACE;IACE,UAAA;EDSJ;ECNE;IACE,UAAA;EDQJ;AACF;ACLE;EACE;IACE,UAAA;EDOJ;ECJE;IACE,UAAA;EDMJ;AACF;ACHE;EACE;IACE,6BAAA;EDKJ;ECFE;IACE,wBAAA;EDIJ;AACF;ACDE;EACE;IACE,8BAAA;EDGJ;ECAE;IACE,wBAAA;EDEJ;AACF;ACCE;EACE;IACE,wBAAA;EDCJ;ECEE;IACE,8BAAA;EDAJ;AACF;ACGE;EACE;IACE,wBAAA;EDDJ;ECIE;IACE,oBAAA;EDFJ;AACF;ACKE;EACE;IACE,oBAAA;EDHJ;ECME;IACE,wBAAA;EDJJ;AACF;ACOE;EACE;IACE,yBAAA;EDLJ;ECQE;IACE,oBAAA;EDNJ;AACF;ACSE;EACE;IACE,UAAA;IACA,yBAAA;EDPJ;ECUE;IACE,UAAA;IACA,oBAAA;EDRJ;AACF;ACWE;EACE;IACE,oBAAA;EDTJ;ECYE;IACE,wBAAA;EDVJ;AACF;ACaE;EACE;IACE,UAAA;IACA,2CAAA;EDXJ;ECaE;IACE,UAAA;IACA,kCAAA;EDXJ;AACF;ACcE;EACE;IACE,UAAA;IACA,2BAAA;EDZJ;ECcE;IACE,UAAA;IACA,wBAAA;EDZJ;AACF;ACeE;EACE;IACE,UAAA;IACA,2BAAA;EDbJ;ECeE;IACE,UAAA;IACA,wBAAA;EDbJ;AACF;ACgBE;EACE;IACE,UAAA;IACA,wBAAA;EDdJ;ECgBE;IACE,UAAA;IACA,4BAAA;EDdJ;AACF;ACiBE;EACE;IACE,4BAAA;EDfJ;ECkBE;IACE,wBAAA;EDhBJ;AACF;AAnII;EDGF,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ECNM,gBAAA;AA0IR;AA/IA;;EAWQ,oBAAA;AAwIR;AAnJA;EAgBQ,sBAAA;AAsIR;AAtJA;EAmBQ,eAAA;EACA,sBAAA;AAsIR;AA1JA;EAwBQ,mBAAA;EACA,qBAAA;EACA,0BAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8DAAA;AAqIR;AAnIQ;EACE,qBAAA;AAqIV;AAnIQ;EACE,2BAAA;AAqIV;AAnIQ;EACE,yBAAA;AAqIV;AAhII;EAEI,+BAAA;ECyGN,4IAAA;ADyBF;AD3FG;EACC,sBAAA;AC6FJ;AD9FG;EACC,sBAAA;ACgGJ;ADjGG;EACC,sBAAA;ACmGJ;ADpGG;EACC,sBAAA;ACsGJ;ADvGG;EACC,sBAAA;ACyGJ;AD1GG;EACC,sBAAA;AC4GJ;AD7GG;EACC,sBAAA;AC+GJ;ADhHG;EACC,sBAAA;ACkHJ;ADnHG;EACC,sBAAA;ACqHJ;ADtHG;EACC,sBAAA;ACwHJ;ADzHG;EACC,sBAAA;AC2HJ;AD5HG;EACC,sBAAA;AC8HJ","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../Styles/textAreaSection.less';\n@import '../../Styles/utilities.less';\n@import '../../Styles/mediaQueries.less';\n@import '../../Styles/animations.less';\n\napp-root {\n  .summary-page {\n    &.lf {\n      h1 {\n        .visually-hidden-content();\n        margin-bottom: 0;\n      }\n    }\n    .summary {\n      .summary-header h2,\n      dt {\n        margin-right: 0.5rem;\n      }\n      // create link padding without impacting layout when it breaks onto new line\n      @link-horizontal-padding: 0.375rem;\n      .summary-value {\n        margin-right: @link-horizontal-padding;\n      }\n      .summary-header h2 {\n        display: inline;\n        margin-right: @link-horizontal-padding;\n      }\n\n      a.edit-link {\n        font-size: 0.875rem;\n        display: inline-block;\n        padding: 0.125rem @link-horizontal-padding;\n        padding-bottom: 0;\n        margin-right: -@link-horizontal-padding;\n        margin-left: -@link-horizontal-padding;\n        text-decoration: none;\n        font-weight: 600;\n        color: var(--primary);\n        transition: color 0.2s ease-in-out, transform 0.1s ease-in-out;\n\n        &:visited {\n          color: var(--primary);\n        }\n        &:hover {\n          color: var(--hover-primary);\n        }\n        &:active {\n          transform: translateY(7%);\n        }\n      }\n    }\n\n    &.slide-in {\n      .summary .summary-entry {\n        will-change: transform, opacity;\n        .cubic-slide-in-animation();\n        .sequential-delay(12, 0.06s, ~'', 0.15s);\n      }\n    }\n  }\n}\n","app-root {\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fade-out {\n    from {\n      opacity: 1;\n    }\n\n    to {\n      opacity: 0;\n    }\n  }\n\n  @keyframes page-transition-slide-in {\n    from {\n      transform: translateX(7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-reverse-slide-in {\n    from {\n      transform: translateX(-7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-slide-out {\n    from {\n      transform: translateX(0);\n    }\n\n    to {\n      transform: translateX(-7.5rem);\n    }\n  }\n\n  @keyframes width-grow {\n    from {\n      transform: scaleX(0.001);\n    }\n\n    to {\n      transform: scaleX(1);\n    }\n  }\n\n  @keyframes width-shrink {\n    from {\n      transform: scaleX(1);\n    }\n\n    to {\n      transform: scaleX(0.001);\n    }\n  }\n\n  @keyframes height-grow {\n    from {\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-fade-and-grow {\n    from {\n      opacity: 0;\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      opacity: 1;\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-shrink {\n    from {\n      transform: scaleY(1);\n    }\n\n    to {\n      transform: scaleY(0.001);\n    }\n  }\n\n  @keyframes roll-in {\n    from {\n      opacity: 0;\n      transform: translateX(10rem) rotate(500deg);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0) rotate(0);\n    }\n  }\n\n  @keyframes slide-up {\n    from {\n      opacity: 0;\n      transform: translateY(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slide-in {\n    from {\n      opacity: 0;\n      transform: translateX(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slide-out {\n    from {\n      opacity: 1;\n      transform: translateX(0);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(-5rem);\n    }\n  }\n\n  @keyframes drop {\n    0% {\n      transform: translateY(-1rem);\n    }\n\n    100% {\n      transform: translateY(0);\n    }\n  }\n}\n\n.cubic-slide-in-animation(@delay: 0s) {\n  animation: 0.25s ease-in normal backwards @delay fade-in,\n    0.3s cubic-bezier(0.39, 0.67, 0.61, 0.96) normal backwards @delay page-transition-slide-in;\n}\n.cubic-reverse-slide-in-animation(@delay: 0s) {\n  animation: 0.4s ease-in normal backwards @delay fade-in,\n    0.2s cubic-bezier(0.23, 0.06, 0.55, 0.42) normal backwards @delay\n      page-transition-reverse-slide-in;\n}\n.cubic-slide-out-animation(@delay: 0s) {\n  animation: 0.3s ease-in @delay forwards fade-out,\n    0.3s cubic-bezier(0.23, 0.06, 0.55, 0.42) @delay forwards page-transition-slide-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
